import { type ActionPayload } from '@a2ui/web_core/v0_9'

export const resolveA2uiActionMessage = (
  action: ActionPayload
): Nullable<string> => {
  const message = action.context?.message
  if (typeof message !== 'string') return null
  const trimmed = message.trim()
  return trimmed || null
}
